import React from 'react'
import * as Styled from './ScreenSizeRestriction.style'
import { useLocation } from 'react-router-dom'

// Logo Imports
import QuestBlackLogo from "@/assets/svg_Landing/QuestBlackLogo.svg"
import PickBlackLogo from "@/assets/svg_Landing/PickBlackLogo.svg"
import LinkBlackLogo from "@/assets/svg_Landing/LinkBlackLogo.svg"

// Store Badges
import PlayStoreImg from '@/assets/images/PlayStore.svg'
import AppleStoreImg from '@/assets/images/AppleStore.svg'

// MockUp Images
import StudentMockUp from '@/assets/images/studentMockUp.svg'
import POMockUp from '@/assets/images/poMockUp.svg'
import HRMockUp from '@/assets/images/hrMockUp.svg'

const ScreenSizeRestriction = () => {
    const location = useLocation();

    const getUserType = () => {
        const path = location.pathname.toLowerCase();
        if (path.includes('/student')) return 'student';
        if (path.includes('/po')) return 'po';
        if (path.includes('/hr')) return 'hr';
        return 'default';
    };

    const userType = getUserType();

    const userConfig = {
        student: {
            logo: LinkBlackLogo,
            mockup: StudentMockUp,
            title: 'Square Link'
        },
        po: {
            logo: PickBlackLogo,
            mockup: POMockUp,
            title: 'Square Quest'
        },
        hr: {
            logo: QuestBlackLogo,
            mockup: HRMockUp,
            title: 'Square Pick'
        },
        default: {
            logo: QuestBlackLogo,
            mockup: StudentMockUp,
            title: 'Square Quest'
        }
    };

    const { logo, mockup, title } = userConfig[userType] || userConfig.default;

    return (
        <Styled.MainContainer>
            <Styled.HeaderContainer>
                <img src={logo} alt={`${userType} logo`} />
                <p>{title}</p>
            </Styled.HeaderContainer>

            <Styled.BodyContainer>
                <Styled.LeftContainer>
                    <h1>Unlock the Full Experience on Our Mobile App!</h1>

                    <p>Our mobile app is designed to give you the best experience possible—optimized for speed, convenience, and all the features you love. Download it now and enjoy seamless access to everything, right at your fingertips!</p>

                    <Styled.CTAContainer>
                        {userType === "student" ? (
                            <>
                                <Styled.CTABtn>
                                    <img src={PlayStoreImg} alt="Play Store" />
                                </Styled.CTABtn>
                                <Styled.CTABtn>
                                    <img src={AppleStoreImg} alt="Apple Store" />
                                </Styled.CTABtn>
                            </>
                        ) : (
                            <Styled.ComingSoon>
                                Exciting Things Are on Their Way! 🚀
                                Stay Tuned for the Big Reveal!
                            </Styled.ComingSoon>
                        )}


                    </Styled.CTAContainer>
                </Styled.LeftContainer>

                <Styled.RightContainer>
                    <img src={mockup} alt={`${userType} mockup`} />
                </Styled.RightContainer>
            </Styled.BodyContainer>
        </Styled.MainContainer>
    );
}

export default ScreenSizeRestriction